import AppMobileBottomNavContainer from "../AppMobileBottomNavContainer";
import MedicationSortForm from "../MedicationSortForm";

const MedicationSortMobileNavbar = ({ isOpen, setIsOpen }) => {
  return (
    <AppMobileBottomNavContainer isOpen={isOpen} setIsOpen={setIsOpen}>
      <MedicationSortForm onClose={() => setIsOpen(false)} />
    </AppMobileBottomNavContainer>
  )
}

export default MedicationSortMobileNavbar